import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 py-20">
      <h1 className="text-4xl font-extrabold text-gray-900 mb-10">Terms and Conditions</h1>
      <p className="text-gray-700 mb-4">
        Welcome to MarketingBirbal. These terms and conditions outline the rules and regulations for the use of our website.
      </p>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Terms</h2>
      <p className="text-gray-700 mb-4">
        By accessing this website, you are agreeing to be bound by these terms of service, all applicable laws and regulations, and agree that you are responsible for compliance with any applicable local laws.
      </p>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Use License</h2>
      <p className="text-gray-700 mb-4">
        Permission is granted to temporarily download one copy of the materials (information or software) on MarketingBirbal’s website for personal, non-commercial transitory viewing only. Under this license you may not:
      </p>
      <ul className="list-disc pl-8 text-gray-700 mb-4">
        <li>Modify or copy the materials</li>
        <li>Use the materials for any commercial purpose, or for any public display (commercial or non-commercial)</li>
        <li>Attempt to decompile or reverse engineer any software contained on MarketingBirbal’s website</li>
        <li>Remove any copyright or other proprietary notations from the materials</li>
        <li>Transfer the materials to another person or "mirror" the materials on any other server</li>
      </ul>
      <p className="text-gray-700 mb-4">
        This license shall automatically terminate if you violate any of these restrictions and may be terminated by MarketingBirbal at any time. Upon terminating your viewing of these materials or upon the termination of this license, you must destroy any downloaded materials in your possession whether in electronic or printed format.
      </p>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Disclaimer</h2>
      <p className="text-gray-700 mb-4">
        The materials on MarketingBirbal’s website are provided on an 'as is' basis. MarketingBirbal makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
      </p>
      <p className="text-gray-700 mb-4">
        Further, MarketingBirbal does not warrant or make any representations concerning the accuracy, likely results, or reliability of the use of the materials on its website or otherwise relating to such materials or on any sites linked to this site.
      </p>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Limitations</h2>
      <p className="text-gray-700 mb-4">
        In no event shall MarketingBirbal or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on MarketingBirbal’s website, even if MarketingBirbal or a MarketingBirbal authorized representative has been notified orally or in writing of the possibility of such damage.
      </p>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Revisions and Errata</h2>
      <p className="text-gray-700 mb-4">
        The materials appearing on MarketingBirbal’s website could include technical, typographical, or photographic errors. MarketingBirbal does not warrant that any of the materials on its website are accurate, complete, or current. MarketingBirbal may make changes to the materials contained on its website at any time without notice. However, MarketingBirbal does not make any commitment to update the materials.
      </p>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Links</h2>
      <p className="text-gray-700 mb-4">
        MarketingBirbal has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by MarketingBirbal of the site. Use of any such linked website is at the user's own risk.
      </p>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Site Terms of Use Modifications</h2>
      <p className="text-gray-700 mb-4">
        MarketingBirbal may revise these terms of use for its website at any time without notice. By using this website you are agreeing to be bound by the then current version of these Terms and Conditions of Use.
      </p>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Governing Law</h2>
      <p className="text-gray-700 mb-4">
        Any claim relating to MarketingBirbal’s website shall be governed by the laws of the Republic of India without regard to its conflict of law provisions.
      </p>
    </div>
  );
};

export default TermsAndConditions;
